module.exports = __webpack_public_path__ + "static/media/menu3.fcf1acdb.png";